<template>
  <div class="container">
    <hr class="pb-10 sm:pb-12">
    <div class="c-inside pb-12 overflow-x-auto md:overflow-x-visible">
      <div class="grid grid-cols-9 lg:gap-8 gap-y-2.5 text-center w-max md:w-full">
        <div class="flex flex-col items-center justify-center gap-2 flex-shrink-0 ">
          <div class="h-10 flex items-center justify-center">
            <img class="w-10 h-10" src="@/assets/icons/svg/BuiltYear_40x40.svg" alt="year"/>
          </div>
          <p class="iconbox__text responsive-body-large mt-2">{{ yacht.year }}</p>
        </div>
        <div class="flex flex-col items-center justify-center gap-2 flex-shrink-0 ">
          <div class="h-10 flex items-center justify-center">
            <img class="w-10 h-10" src="@/assets/icons/svg/Cabin_40x40.svg" alt="cabins"/>
          </div>
          <p class="iconbox__text responsive-body-large mt-2">{{ yacht.cabins }} {{ t('cabins') }}</p>
        </div>
        <div class="flex flex-col items-center justify-center gap-2 flex-shrink-0 ">
          <div class="h-10 flex items-center justify-center">
            <img class="w-10 h-10" src="@/assets/icons/svg/Bed_40x40.svg" alt="berth"/>
          </div>
          <p class="iconbox__text responsive-body-large mt-2">{{ yacht.berths }} {{ t('berths') }}</p>
        </div>
        <div class="flex flex-col items-center justify-center gap-2 flex-shrink-0 ">
          <div class="h-10 flex items-center justify-center">
            <img class="w-10 h-10" src="@/assets/icons/svg/Length_40x40.svg" alt="length"/>
          </div>
          <p class="iconbox__text responsive-body-large mt-2">{{ formatStore.formatLength(yacht.length) }}</p>
        </div>
        <div class="flex flex-col items-center justify-center gap-2 flex-shrink-0 ">
          <div class="h-10 flex items-center justify-center">
            <img class="w-10 h-10" src="@/assets/icons/svg/Mainsali_40x40.svg" alt="sailType"/>
          </div>
          <p class="iconbox__text responsive-body-large mt-2 text-center leading-snug">{{ yacht.sailType?.name }}</p>
        </div>
        <div v-if="yacht.draught" class="flex flex-col items-center justify-center gap-2 flex-shrink-0">
          <div class="h-10 flex items-center justify-center">
            <img class="w-10 h-10" src="@/assets/icons/svg/Draft_40x40.svg" alt="draught"/>
          </div>
          <p class="iconbox__text responsive-body-large mt-2">{{ formatStore.formatLength(yacht.draught) }}</p>
        </div>
        <div class="flex flex-col items-center justify-center gap-2 flex-shrink-0 ">
          <div class="h-10 flex items-center justify-center">
            <img class="w-10 h-10" src="@/assets/icons/svg/fuel_40x40.svg" alt="fuelCapacity"/>
          </div>
          <p class="iconbox__text responsive-body-large mt-2">{{ yacht.fuelCapacity }} l</p>
        </div>
        <div class="flex flex-col items-center justify-center gap-2 flex-shrink-0 ">
          <div class="h-10 flex items-center justify-center">
            <img class="w-10 h-10" src="@/assets/icons/svg/Water_tank_40x40.svg" alt="waterCapacity"/>
          </div>
          <p class="iconbox__text responsive-body-large mt-2">{{ formatStore.formatWeight(yacht.waterCapacity) }}</p>
        </div>
        <div class="flex flex-col items-center justify-center gap-2 flex-shrink-0 ">
          <div class="h-10 flex items-center justify-center">
            <img class="w-10 h-10" src="@/assets/icons/svg/Engine_40x40.svg" alt="engine"/>
          </div>
          <p class="iconbox__text responsive-body-large mt-2 text-center leading-snug">{{ yacht.engine }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useFormatStore } from "@/stores/formatStore";

const props = defineProps({
  yacht: {
    type: Object,
    required: true
  }
})

const { t } = useI18n()
const formatStore = useFormatStore()

</script>
